import { groupEntities } from '@front/model'
import { type TableColumnDef } from './types'

type ColumnGroup<T extends TableColumnDef> = { columns: T[]; selected: number }
export type GroupedColumnDefs<T extends TableColumnDef> = {
  other: ColumnGroup<T>
  groups: Map<string, ColumnGroup<T>>
}
export const groupColumns = <T extends TableColumnDef>(columns: T[], selected: string[]): GroupedColumnDefs<T> => {
  const grouped = groupEntities(columns, 'group')
  const { other = [], ...groups } = grouped
  const selectedSet = new Set(selected)
  return {
    other: { columns: other, selected: other.filter((c) => selectedSet.has(c.id)).length },
    groups: new Map(
      Object.entries(groups).map(([k, v]) => [
        k,
        { columns: v, selected: v.filter((c) => selectedSet.has(c.id)).length },
      ])
    ),
  }
}
